import React from "react";

import FacebookIdentity from "../FacebookIdentity";
import SectionHeader from "../SectionHeader";

const Identities = () => {
  return (
    <>
      <SectionHeader>Connected Accounts</SectionHeader>

      <FacebookIdentity />
    </>
  );
};

export default Identities;
